import { AttributionBudgetModelDto, EditerExecutionAttributionAutoModel } from 'src/graphql/generated-types';
import { AllocationEdition } from 'src/app/_shared/services/allocations/detail/allocation.service';

const stateName = '[SubventionAllocation] ';

export class SubventionAllocationGetAction {
    static type = stateName + 'get Allocation';

    constructor(public allocationId?: number) {
    }
}

export class SubventionAllocationLoadRelatedListAction {
    static type = stateName + 'load related list';
}

export class SubventionAllocationSaveAction {
    static type = stateName + 'save Allocation';

    constructor(public model: AllocationEdition) {
    }
}

export class SubventionAllocationSaveAutomatedExecutionAction {
    static type = stateName + 'save Allocation Automated Execution';

    constructor(public executionModel?: EditerExecutionAttributionAutoModel) {
    }
}

export class SubventionAllocationArchiveAction {
    static type = stateName + 'archive Allocation';

    constructor(public allocationId: number) {
    }
}

export class SubventionAllocationReloadListAction {
    static type = stateName + 'reload Allocations list';
    constructor(public allocationId: number = null) {
    }
}
